import classNames from 'classnames'
import React, { useMemo, useState } from 'react'
import Container from '../../../../Context'
import { useTranslation } from '../../../../hooks'
import { powerBy } from '../../../MenuDialog/index'
import styles from './index.module.less'

const Guide: React.FC = () => {
  const { shutdownGuidTips } = Container.useContainer()
  const [animation, setAnimation] = useState<string>(styles.guideAnimation)
  const handleAnimationEnd = () => {
    setAnimation('')
    setTimeout(() => {
      setAnimation(styles.guideAnimation)
    }, 3000)
  }
  const { t } = useTranslation()

  const tips = useMemo(() => {
    return t('feedback.tips').replace('OneShip', powerBy)
  }, [t])

  return (
    <div className={classNames(styles['guide-wrap'], animation)} onAnimationEnd={handleAnimationEnd}>
      {tips}
      <div>
        <button className={styles.button} onClick={shutdownGuidTips}>
          {t('feedback.iknow')}
        </button>
      </div>
    </div>
  )
}

export default Guide
